import styles from "./styles.module.scss";
import "./organicTable.css";
import { Table } from "antd";
import { mockData } from "./mock";
import classNames from "classnames";
import Input from "antd/lib/input/Input";
import Search from "@assets/icons/search";
import { useState } from "react";

const generateColumns = () => {
  return [
    {
      title: "Campaigns",
      dataIndex: "campaignName",
      key: "campaignName",
      render: (text: string, record: any) => (
        <div className={styles.campaignName}>
          <div className={styles.info}>
            <a className={styles.link}>{text}</a>
            <button className={styles.campaignEdit}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M1.11111 8.88889H1.90278L7.33333 3.45833L6.54167 2.66667L1.11111 8.09722V8.88889ZM0 10V7.63889L7.33333 0.319444C7.44445 0.217593 7.56722 0.138889 7.70167 0.0833334C7.83611 0.0277778 7.97722 0 8.125 0C8.27278 0 8.4163 0.0277778 8.55556 0.0833334C8.69481 0.138889 8.81519 0.222222 8.91667 0.333333L9.68056 1.11111C9.79167 1.21296 9.87278 1.33333 9.92389 1.47222C9.975 1.61111 10.0004 1.75 10 1.88889C10 2.03704 9.97463 2.17833 9.92389 2.31278C9.87315 2.44722 9.79204 2.56981 9.68056 2.68056L2.36111 10H0ZM6.93056 3.06944L6.54167 2.66667L7.33333 3.45833L6.93056 3.06944Z"
                  fill="#7C7C78"
                />
              </svg>
            </button>
          </div>
          <span className={styles.campaignId}>{record.campaignId}</span>
        </div>
      ),
    },
    {
      title: "Click-Throughs",
      dataIndex: "clickThroughs",
      key: "clickThroughs",
      render: (text: any) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "DPV",
      dataIndex: "dpv",
      key: "dpv",
      render: (text: any) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "DPV Clicks",
      dataIndex: "dpvClicks",
      key: "dpvClicks",
      render: (text: any) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "ATC",
      dataIndex: "atc",
      key: "atc",
      render: (text: any) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "ATC Clicks",
      dataIndex: "atcClicks",
      key: "atcClicks",
      render: (text: any) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "Product Sales",
      dataIndex: "productSales",
      key: "productSales",
      render: (text: string) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "Product Sales Clicks",
      dataIndex: "productSalesClicks",
      key: "productSalesClicks",
      render: (text: string) => <span style={{ color: "#fff" }}>{text}</span>,
    },
    {
      title: "Brand Referral Bonus",
      dataIndex: "brandReferralBonus",
      key: "brandReferralBonus",
      render: (text: string) => <span style={{ color: "#fff" }}>{text}</span>,
    },
  ];
};

const Organic = () => {
  const [view, setView] = useState("Week View");

  const handleViewChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setView(e.target.value);
  };

  return (
    <div className={styles.organicWrapper}>
      <div className={classNames(styles.twrapper, "organic-table")}>
        <div className={styles.tActions}>
          <div className={styles.inputWithIcon}>
            <Input
              className={styles.inputField}
              placeholder="Search campaigns"
            />
            <div className={styles.icon}>
              <Search />
            </div>
          </div>
          <div className={styles.tActionsRight}>
            <button className={styles.tActionsCustomize}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M2 5.33301L10 5.33301M10 5.33301C10 6.43758 10.8954 7.33301 12 7.33301C13.1046 7.33301 14 6.43758 14 5.33301C14 4.22844 13.1046 3.33301 12 3.33301C10.8954 3.33301 10 4.22844 10 5.33301ZM6 10.6663L14 10.6663M6 10.6663C6 11.7709 5.10457 12.6663 4 12.6663C2.89543 12.6663 2 11.7709 2 10.6663C2 9.56177 2.89543 8.66634 4 8.66634C5.10457 8.66634 6 9.56177 6 10.6663Z"
                  stroke="#7C7C78"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Customize columns
            </button>
            <select
              className={styles.selectDropdown}
              value={view}
              onChange={handleViewChange}
            >
              <option value="Week View">Week View</option>
              <option value="Month View">Month View</option>
            </select>
          </div>
        </div>
        <Table
          columns={generateColumns()}
          dataSource={mockData}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default Organic;
